export const getGraphQlErrorMessage = (errors) => {
  console.log("setGraphQlError", errors);
  return errors.reduce(
    (message, item, i) => (message += (i === 0 ? "" : "--") + item.message),
    ""
  );
};
